import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { getStates } from '../../../api/api';
import { toast } from 'react-hot-toast';

export default function Step3({
  formData,
  setFormData,
  errors,
  nextStep,
  handleChange,
  prevStep,
}) {
  const [states, setStates] = useState([]);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const res = await getStates();
        if (res.success) {
          setStates(res.states);
        } else {
          toast.error('Failed to load states');
        }
      } catch (err) {
        toast.error(err.message || 'Error fetching states');
      }
    };

    fetchStates();
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
      className="h-[400px] overflow-y-auto"
    >
      <motion.h2
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.6 }}
        className="text-2xl font-bold text-gray-900 mb-2"
      >
        Legal Preferences
      </motion.h2>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.6 }}
        className="text-sm font-semibold text-gray-600 mb-6"
      >
        We tailor your experience based on where you practice or need legal
        insights.
      </motion.p>

      <motion.form
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.6 }}
        className="space-y-4"
      >
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Select Your U.S. State<span className="text-red-500">*</span>
          </label>
          <select
            name="usState"
            value={formData.usState}
            onChange={(e) => handleChange('usState', e.target.value)}
            className="w-full border border-gray-300 rounded px-4 py-3 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
          >
            <option value="">Select State</option>
            {states.map((state) => (
              <option key={state.id} value={state.name}>
                {state.name}
              </option>
            ))}
          </select>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.6 }}
          className="flex justify-end gap-3 mt-6"
        >
          <motion.button
            type="button"
            onClick={prevStep}
            className="w-24 py-2 border border-brand text-brand rounded hover:bg-indigo-50 transition font-medium"
          >
            Back
          </motion.button>

          <motion.button
            type="button"
            onClick={nextStep}
            className="w-36 py-2 bg-gradient-to-r from-brandDark to-brand text-white rounded hover:bg-brand transition font-medium"
          >
            Next
          </motion.button>
        </motion.div>
      </motion.form>
    </motion.div>
  );
}
